import { BaseResponse } from './base.response';

export class SignInResponse extends BaseResponse {

  public messages: string[];
  public status: string;
  public token: string;

}
